module.exports = __webpack_public_path__ + "media/images/apple_health/watch/purebarre-846fcc72030a8802ba7092350936ede2.svg";